import React from 'react';
import { Drawer as DrawerPrimitive } from 'vaul';
import { cn } from '@/lib/utils';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { DrawerOverlay, DrawerPortal, DrawerTitle } from '../default/drawer';

export const CustomDrawerContent = React.forwardRef<
  React.ElementRef<typeof DrawerPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Content> & {
    visuallyHiddenTitle: string;
  }
>(({ className, visuallyHiddenTitle, children, ...props }, ref) => (
  <DrawerPortal>
    <DrawerOverlay />
    <DrawerPrimitive.Content
      ref={ref}
      className={cn(
        'fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-t-[10px] border bg-background',
        className,
      )}
      {...props}
    >
      {/* NOTE: ブラウザのエラー回避 */}
      {/* If you want to hide the `DialogTitle`, you can wrap it with our VisuallyHidden component. */}
      <VisuallyHidden asChild>
        <DrawerTitle>{visuallyHiddenTitle}</DrawerTitle>
      </VisuallyHidden>
      {children}
    </DrawerPrimitive.Content>
  </DrawerPortal>
));
CustomDrawerContent.displayName = 'CustomDrawerContent';
